var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.7 35.7",
    style: {
      enableBackground: "new 0 0 35.7 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.8535,
    y1: 34.8871,
    x2: 17.8535,
    y2: 0.8199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A043C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M18.1,5.7c-0.6-0.4-1.4-0.4-2,0l-8.5,4.9H2.2c-1.1,0-2,0.9-2,2V23c0,1.1,0.9,2,2,2h5.3 l8.5,4.9c0.3,0.2,0.7,0.3,1,0.3s0.7-0.1,1-0.3c0.6-0.4,1-1,1-1.8V7.5C19.2,6.8,18.8,6.1,18.1,5.7z M16.4,26.9l-8.1-4.7H3v-8.8h5.3 l8.1-4.7V26.9z M24.5,5.6c-0.5-0.5-1.4-0.5-2,0s-0.5,1.4,0,2c2.6,2.6,4,6.1,4,9.8c0,3.9-1.6,7.6-4.5,10.2c-0.6,0.5-0.6,1.4-0.1,2 c0.3,0.3,0.7,0.5,1,0.5c0.3,0,0.7-0.1,0.9-0.4c3.5-3.1,5.4-7.6,5.4-12.3C29.4,12.9,27.7,8.7,24.5,5.6z M28.9,1.2 c-0.5-0.5-1.4-0.5-2,0c-0.5,0.5-0.5,1.4,0,2c3.8,3.8,5.8,8.8,5.8,14.1c0,5.8-2.5,11.3-6.9,15.1c-0.6,0.5-0.7,1.4-0.1,2 c0.3,0.3,0.7,0.5,1.1,0.5c0.3,0,0.6-0.1,0.9-0.3c5-4.3,7.9-10.6,7.9-17.2C35.5,11.2,33.2,5.5,28.9,1.2z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundButton);
export default __webpack_public_path__ + "static/media/sound_button.8326dae15b17d75c607994e3de4af20c.svg";
export { ForwardRef as ReactComponent };